// Phase 4a customer-portal — small formatters used across portal
// pages. Money is always integer-cent → $X,XXX.XX (FR-12 / AC-8).
// Dates use America/Denver since that's the customer's reference
// frame; single-region v1 per Phase 4e CO-only storefront.

export function formatMoneyCents(cents: number | null | undefined): string {
  if (cents == null) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(cents / 100);
}

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export function formatDate(value: string | null | undefined): string {
  if (value == null) return "—";
  // Date-only strings (`YYYY-MM-DD`) are timezone-agnostic — parsing
  // them via `new Date()` lands at UTC midnight, which renders as the
  // previous calendar day in Denver. Format them from their parts
  // instead so the customer-visible date matches the server-stored
  // date column exactly.
  if (DATE_ONLY.test(value)) {
    const [year, month, day] = value.split("-").map(Number);
    const local = new Date(year, month - 1, day);
    return local.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
    });
  }
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString("en-US", {
    timeZone: "America/Denver",
    month: "short",
    day: "numeric",
    year: "numeric"
  });
}

export function formatDateTime(value: string | null | undefined): string {
  if (value == null) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString("en-US", {
    timeZone: "America/Denver",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });
}

export function daysLabel(days: number | null): string {
  if (days == null) return "—";
  if (days === 0) return "today";
  if (days > 0) return `in ${days}d`;
  return `${Math.abs(days)}d ago`;
}
